import { render, staticRenderFns } from "./activeChatAssign.vue?vue&type=template&id=17b70bc5&"
import script from "./activeChatAssign.vue?vue&type=script&lang=js&"
export * from "./activeChatAssign.vue?vue&type=script&lang=js&"
import style0 from "./activeChatAssign.vue?vue&type=style&index=0&id=17b70bc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports